<template>
  <div class="newView">
    <div class="indexData">
      <div class="top">
        <div class="companyTitle">公司简介</div>
        <img src="http://video.naolamp.com/officialWeb/company/company.jpg" alt="">
      </div>
      <div class="content">
        <div class="text">
          <p>广州车灯师信息科技有限公司是一家专注于高端LED车灯以及智能车灯生态链建设的创新型科技企业。</p>
          <p>“让每个人享受车灯带来的乐趣”是车灯师公司的愿景。车灯师公司通过建设信息化系统和应用互联网新零售模式，用工匠精神做产品，用渠道重构思维经营通路，用互联网思维运营品牌，用新零售模式让车主享受高效服务，无论是生产还是通路，无论是门店还是车主，都能开心享受车灯带来的乐趣。</p>
          <p>公司创始人孙海彬先生，为法国图卢兹商学院DBA工商管理博士生，暨南大学工商管理硕士，创业13年，具有丰富的理论知识和实践经验。公司有产品和软件研发团队、设计团队、品牌运营推广团队和营销团队，团队成员80%以上拥有大学本科学历，具备极强学习能力和执行能力。</p>
        </div>
        <div class="company_1">
          <img src="http://video.naolamp.com/images/index/company_1.jpg"/>
        </div>
        <div class="text">
          <p>车灯师公司高度重视产品品质，精选优质原材料和供应商，生产过程严格按照品控标准生产，所有车灯上市前，都必须经过专业质检团队6轮检查管控，确保出厂产品品质符合高标准。公司有车灯师D40LED双光透镜、D32、D26、T7货车LED车灯以及灵耀普及型车灯五大系列，今年全新推出升级版D32和D26二代车灯产品，这两大系列产品在光通量和稳定性上面都有极大的提升；另外还推出了T7货车LED高亮大灯，D40LED双光透镜以及“灵耀”系列普及型LED车灯；公司为门店专门开发了车灯接单软件“车灯师APP”，用户扫线上或线下海报上的二维码-输入手机号-门店即可接单。</p>
          <p>践行知行合一，车灯师公司坚定前行，不断提升核心竞争力，为LED车灯生态链进步创造价值。</p>
        </div>
        <div class="company_2">
          <img src="http://video.naolamp.com/images/index/company_2.jpg"/>
        </div>
        <div class="text_title">认证证书</div>
        <div class="company_3">
          <img src="http://video.naolamp.com/images/index/company_3.png"/>
        </div>
      </div>
    </div>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </div>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  name: 'userMain',
  data () {
    return {
      msg: '公司简介',
      isLoad: true
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.isLoad = false
  },
  methods: {
  },
  filters: {
  },
  components: {
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newView {
  padding-top: 52px;
  background-color: #FFFFFF;
  font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
  border-bottom: 1px solid #e8e8e8;
}
.top img{
  width: 100%;
}
.companyTitle {
  position: absolute;
  width: 100%;
  min-width: 1200px;
  padding-top: 100px;
  color: white;
  font-size: 30px;
}
.content{
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0;
  color: #333333;
  align-content: left;
}
.text{
  line-height: 26px;
  letter-spacing:2px;
  text-align: left;
}
.text p {
  margin-top: 30px;
}
.company_1 {
  margin-top: 70px;
  margin-bottom: 49px;
}
.company_2 {
  margin-top: 70px;
  margin-bottom: 96px;
}
.text_title {
  font-size: 30px;
  font-weight: 600;
}
.company_3 {
  margin-top: 63px;
  margin-bottom: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/company.vue